import { IRealizarRenegociacaoSienge } from "../../../Interfaces/Cobranca/RenegociacaoSienge/RenegociacaoSiengeInterface";
import {
    ListarIndexadoresSiengeService,
    ListarPortadoresSiengeService,
    ListarTiposCondicaoPagamentoSiengeService,
    RealizarRenegociacaoSiengeService,
} from "../../../Services/Cobranca/RenegociacaoSienge/RenegociacaoSiengeService";
import { Controller } from "../../Controller";

export async function ListarTiposCondicaoPagamentoSiengeController(
    pesquisa: string
) {
    return Controller(ListarTiposCondicaoPagamentoSiengeService(pesquisa));
}

export async function ListarPortadoresSiengeController() {
    return Controller(ListarPortadoresSiengeService());
}

export async function ListarIndexadoresSiengeController() {
    return Controller(ListarIndexadoresSiengeService());
}

export async function RealizarRenegociacaoSiengeController(
    idCaso: number,
    requestBody: IRealizarRenegociacaoSienge
) {
    return Controller(RealizarRenegociacaoSiengeService(idCaso, requestBody));
}
